const SLIDER_CONFIG = {

  tilesTeaser: {
    speed: 800,
    slidesPerView: 1.5,
    spaceBetween: 20,
    freeMode: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },

    keyboard: {
      enabled: true
    },

    breakpoints: {

      768: {
        slidesPerView: 2.5
      },

      990: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    }
  },



  bleedTeaser: {
    speed: 800,
    slidesPerView: 1.25,
    spaceBetween: 30,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },

    keyboard: {
      enabled: true
    },

    breakpoints: {

      768: {
        slidesPerView: 1.3
      },

      990: {
        spaceBetween: 60,
        slidesPerView: 1.4
      }
    }
  },



  mediaTeaser: {
    speed: 800,
    slidesPerView: 1.25,
    spaceBetween: 30,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },

    keyboard: {
      enabled: true
    },

    breakpoints: {

      768: {
        slidesPerView: 2.3
      },

      990: {
        spaceBetween: 20,
        slidesPerView: 2.7
      }
    }
  },



  logoSlider: {
    speed: 800,
    loop: true,
    slidesPerView: 2.8,
    spaceBetween: 55,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },

    keyboard: {
      enabled: true
    },

    breakpoints: {

      768: {
        slidesPerView: 4.3
      },

      990: {
        slidesPerView: 6.5
      }
    }
  },



  largeSliderTeaser: {
    speed: 800,
    slidesPerView: 1.25,
    spaceBetween: 30,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },

    keyboard: {
      enabled: true
    },

    breakpoints: {

      768: {
        slidesPerView: 1.4
      },

      990: {
        slidesPerView: 2.8,
        spaceBetween: 50
      }
    }
  }
}